import React, { useState } from "react";
import { Box, InputBase, Chip, IconButton } from "@mui/material";
import { FaSearch, FaChevronRight } from "react-icons/fa";

const categories = [
  "All", "Promo", "MLB", "MLB-Combos", "NBA", "NBA-Combos", "NBA H1", "NBA Q1",
  "WNBA", "NHL", "CSGO", "LoL", "UFC", "ATP", "WTA", "Cricket"
];

const HeaderSection = () => {
  const [selectedCategory, setSelectedCategory] = useState("All");

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        borderRadius: "20px",
        padding: "12px 16px",
        display: "flex",
        alignItems: "center",
        flexWrap: "nowrap",
        overflowX: "auto",
        boxShadow: "0 4px 10px rgba(0,0,0,0.05)"
      }}
    >
      {/* Search Bar */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "#f5f5f5",
          padding: "6px 12px",
          borderRadius: "999px",
          mr: 2,
          flexShrink: 0
        }}
      >
        <FaSearch size={14} style={{ marginRight: 8, color: "#999" }} />
        <InputBase
          placeholder="Search player or team"
          sx={{
            fontSize: "14px",
            width: "160px"
          }}
        />
      </Box>

      {/* Category Chips */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          overflowX: "auto",
          flexGrow: 1
        }}
      >
        {categories.map((cat) => (
          <Chip
            key={cat}
            label={cat}
            onClick={() => setSelectedCategory(cat)}
            sx={{
              borderRadius: "999px",
              backgroundColor: selectedCategory === cat ? "#FFD700" : "#eee",
              color: selectedCategory === cat ? "#000" : "#333",
              fontWeight: selectedCategory === cat ? "bold" : "normal",
              height: "32px",
              padding: "0 8px",
              cursor: "pointer"
            }}
          />
        ))}
      </Box>

      {/* Filter Button */}
      <IconButton
        sx={{
          ml: 2,
          backgroundColor: "#222",
          color: "#fff",
          borderRadius: "999px",
          px: 2,
          py: 1,
          flexShrink: 0
        }}
      >
        <FaChevronRight size={12} style={{ marginRight: 6 }} />
        <span style={{ fontSize: 14 }}>Filter</span>
      </IconButton>
    </Box>
  );
};

export default HeaderSection;